import React, { useState } from 'react'
import FilterWizardModal from '../../FilterWizardModal/FilterWizardModal'
import Section from '../../atoms/Section/Section'
import Container from '@/components/Container'
import IconChevronRight from '@/components/icons/IconChevronRight/IconChevronRight'
import IconRightArrow from '@/components/IconRightArrow/IconRightArrow'
import IconHandHeart from '@/components/icons/IconHandHeart/IconHandHeart'
import Button from '../../atoms/Button/ButtonV2'

const FilterWizardSection = ({ isSection = true }) => {
  const [isFilterWizardModalVisible, setIsFilterWizardModalVisible] =
    useState(false)

  const filterWizardSection = (
    <div
      onClick={() => {
        setIsFilterWizardModalVisible(true)
      }}
      className="group flex w-full cursor-pointer items-center justify-between self-stretch rounded-2xl border
       border-primary-100 bg-primary-50 p-4 hover:bg-primary-100 active:bg-primary-150 md:p-6"
    >
      <div className="flex items-center gap-4">
        <div
          className="flex size-10 items-center justify-center rounded-[10px] bg-primary-150 p-2 
          group-active:bg-primary-200 md:size-11 "
        >
          <IconHandHeart
            className="size-6 text-primary-900"
            strokeWidth={1.2}
          />
        </div>
        <div className="flex flex-col items-start gap-0.5 md:gap-0">
          <p className="font-FieldsVariable font-medium text-primary-900 md:text-lg">
            Need help finding care?
          </p>
          <p className="text-xs text-gray-800 md:text-sm">
            Let us point you in the right direction.
          </p>
        </div>
      </div>

      <Button
        type="tertiary"
        className="hidden md:flex"
      >
        <span className="text-center text-gray-900">Start Your Journey</span>

        <IconRightArrow className="size-4 text-gray-900" />
      </Button>

      <div className="flex items-center justify-center md:hidden">
        <IconChevronRight className="text-gray-1100" />
      </div>
    </div>
  )

  return (
    <>
      <FilterWizardModal
        isFilterWizardModalVisible={isFilterWizardModalVisible}
        onClose={() => setIsFilterWizardModalVisible(false)}
      />
      {isSection ? (
        <Section>
          <Container>{filterWizardSection}</Container>
        </Section>
      ) : (
        <>{filterWizardSection}</>
      )}
    </>
  )
}

export default FilterWizardSection
